import React, { useEffect, useState } from 'react';
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  Container,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Switch,
  Avatar,
  Alert,
  Divider,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Menu,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  useTheme,
  useMediaQuery,
  Stack,
  Drawer,
  InputAdornment,
} from '@mui/material';
import {
  Business,
  Policy,
  Save,
  Clear,
  Code,
  CreditCard,
  Visibility,
  CheckCircle,
  Cancel,
  MoreVert,
  Edit,
  Delete,
  Close,
  Add,
  ViewList,
  Menu as MenuIcon,
  ExpandMore,
  ExpandLess,
  Search,
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import { deleteInsurances, deletePolicy, loadInsurance , loadpolicy, NewInsurance, newPolicy, updateInsurance, updatePolicy } from '../BaseURL';
import axios from 'axios';
import { ErrorMessage, successMessage } from '../Message';


function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: { xs: 2, md: 3 } }}>{children}</Box>}
    </div>
  );
}

// Responsive Navigation Component
const ResponsiveNavigation = ({ tabValue, handleTabChange, editingCompany, editingPolicy }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
 
  const tabs = [
    { 
      icon: <Business />, 
      label: editingCompany ? "Edit Company" : "Register Company",
      shortLabel: editingCompany ? "Edit Co." : "Add Co."
    },
    { 
      icon: <Business />, 
      label: "Companies List",
      shortLabel: "Companies"
    },
    { 
      icon: <Policy />, 
      label: "Policies List",
      shortLabel: "Policies"
    },
    { 
      icon: <Policy />, 
      label: editingPolicy ? "Edit Policy" : "Register Policy",
      shortLabel: editingPolicy ? "Edit Pol." : "Add Pol."
    },
  ];

  if (isMobile) {
    return (
      <>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              '& .MuiTab-root': {
                minWidth: 'auto',
                px: 1,
                fontSize: '0.75rem',
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab 
                key={index}
                icon={tab.icon} 
                label={tab.shortLabel}
                iconPosition="top"
              />
            ))}
          </Tabs>
        </Box>
      </>
    );
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs 
        value={tabValue} 
        onChange={handleTabChange} 
        aria-label="insurance management tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab 
            key={index}
            icon={tab.icon} 
            label={tab.label} 
            iconPosition="start"
          />
        ))}
      </Tabs>
    </Box>
  );
};

// Insurance Company Form Component
const InsuranceCompanyForm = ({ onSubmit, editingCompany, onCancel }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  

  // Initialize form data with proper mapping from API response
  const [formData, setFormData] = useState(() => {
    
    if (editingCompany) {
      return {
        insuranceName: editingCompany.name || '',
        isClaimCheckRequired: editingCompany.ccc === 'Required'|| editingCompany.ccc === '1' ,
        showNonInsuranceMedication: editingCompany.med === 'yes' || editingCompany.med === '1' ,
        visitPerMonth: editingCompany.Vsit || '',
        claimCheckCodeCount: editingCompany.cccc || '',
        membershipNoCount: editingCompany.member_count || '',
        cardSerialNoCount: editingCompany.Seria_count || '',
        cardTypes: editingCompany.Seria || '',
        supportDualInsurance: editingCompany.support === 1,
      };
    }
    return {
      insuranceName: '',
      isClaimCheckRequired: false,
      showNonInsuranceMedication: false,
      visitPerMonth: '',
      claimCheckCodeCount: '',
      membershipNoCount: '',
      cardSerialNoCount: '',
      cardTypes: '',
      supportDualInsurance: false,
    };
  });

  const [errors, setErrors] = useState({});
 
  // Update form data when editingCompany changes
  useEffect(() => {
    if (editingCompany) {
      setFormData({
        insuranceName: editingCompany.name || '',
        isClaimCheckRequired: editingCompany.ccc === 'Required'|| editingCompany.ccc === '1' ,
        showNonInsuranceMedication: editingCompany.med === 'yes' || editingCompany.med === '1' ,
        visitPerMonth: editingCompany.Vsit || '',
        claimCheckCodeCount: editingCompany.cccc || '',
        membershipNoCount: editingCompany.member_count || '',
        cardSerialNoCount: editingCompany.Seria_count || '',
        cardTypes: editingCompany.Seria || '',
       supportDualInsurance: editingCompany.support === 1,
      });
    } else {
      setFormData({
        insuranceName: '',
        isClaimCheckRequired: false,
        showNonInsuranceMedication: false,
        visitPerMonth: '',
        claimCheckCodeCount: '',
        membershipNoCount: '',
        cardSerialNoCount: '',
        cardTypes: '',
        supportDualInsurance: false,
      });
    }
  }, [editingCompany]);
 
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.insuranceName.trim()) {
      newErrors.insuranceName = 'Insurance name is required';
    }

    if (!formData.visitPerMonth || formData.visitPerMonth <= 0) {
      newErrors.visitPerMonth = 'Please enter a valid number of visits per month';
    }

    if (!formData.cardTypes.trim()) {
      newErrors.cardTypes = 'Please enter at least one card type';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

 const handleSubmit = async(e) => {
  e.preventDefault();

  if (validateForm()) {
     const result = await Swal.fire({
      title: 'Confirm / Cancel',
      text: editingCompany ? "Are You Sure You Want To Update Insurance Company ?" : "Are You Sure You Want To Register Insurance Company ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes Confirm'
  });

  if (result.isConfirmed) {
      Swal.fire({
      title: 'Processing.......',
      text: 'Please wait',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
      Swal.showLoading();
      }
      }); 
      
      try {
        if (editingCompany) {
          // Update existing company
         
          const updateData = {
            ...formData,
            id: editingCompany.id
          };
          
         // console.log(updateData)

          
           const response = await axios.put(updateInsurance(updateData.id), updateData);
                      
              if (response.data.success) {
      
              successMessage('Save',response.data.message)
              
              // Call onSubmit with true to trigger refresh
              onSubmit(true);
              }

        } else {
          // Create new company
          const response = await axios.post(NewInsurance, formData);
                      
          if (response.data.success) {
            successMessage('Save', response.data.message);
            
            // Call onSubmit with true to trigger refresh
            onSubmit(true);
          }
        }

      
       handleReset();

      } catch (error) {
        await Swal.fire({
          title: 'Error',
          text: error.response?.data?.message || 'Failed to Save',
          icon: 'error'
        });
      }

    }
  }
};

  const handleReset = () => {
    setFormData({
      insuranceName: '',
      isClaimCheckRequired: false,
      showNonInsuranceMedication: false,
      visitPerMonth: '',
      claimCheckCodeCount: '',
      membershipNoCount: '',
      cardSerialNoCount: '',
      cardTypes: '',
      supportDualInsurance: false,
    });
    setErrors({});
  };

  const cardTypesArray = typeof formData.cardTypes === 'string' 
    ? formData.cardTypes.split(',').map(type => type.trim()).filter(type => type)
    : formData.cardTypes || [];

  return (
    <Card>
      <CardHeader
        avatar={<Business color="primary" />}
        title={
          <Typography variant={isMobile ? "h6" : "h5"}>
            {editingCompany ? "Update Insurance Company" : "Register Insurance Company"}
          </Typography>
        }
        subheader={editingCompany ? "Modify company information" : "Enter all required information to register a new insurance company"}
        action={
          editingCompany && onCancel && (
            <IconButton onClick={onCancel}>
              <Close />
            </IconButton>
          )
        }
      />
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={{ xs: 2, sm: 3 }}  columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={12} md={6} size={4}>
              <TextField
                fullWidth
                label="Insurance Company Name"
                name="insuranceName"
                value={formData.insuranceName}
                onChange={handleInputChange}
                error={!!errors.insuranceName}
                helperText={errors.insuranceName}
                required
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <TextField
                fullWidth
                label="Claim Check Code Count"
                name="claimCheckCodeCount"
                type="number"
                value={formData.claimCheckCodeCount}
                onChange={handleInputChange}
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <FormControlLabel
                control={
                  <Switch
                    name="isClaimCheckRequired"
                    checked={formData.isClaimCheckRequired}
                    onChange={handleInputChange}
                    size={isMobile ? "small" : "medium"}
                  />
                }
                label="Claim Check Code Required"
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <TextField
                fullWidth
                label="Visits Per Month"
                name="visitPerMonth"
                type="number"
                value={formData.visitPerMonth}
                onChange={handleInputChange}
                error={!!errors.visitPerMonth}
                helperText={errors.visitPerMonth}
                required
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <TextField
                fullWidth
                label="Membership Number Count"
                name="membershipNoCount"
                type="number"
                value={formData.membershipNoCount}
                onChange={handleInputChange}
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <FormControlLabel
                control={
                  <Switch
                    name="showNonInsuranceMedication"
                    checked={formData.showNonInsuranceMedication}
                    onChange={handleInputChange}
                    size={isMobile ? "small" : "medium"}
                  />
                }
                label="Show Non Insurance Medication"
              />
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <TextField
                fullWidth
                label="Card Serial Number Count"
                name="cardSerialNoCount"
                type="number"
                value={formData.cardSerialNoCount}
                onChange={handleInputChange}
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

             <Grid item xs={12} size={4} >
              <TextField
                fullWidth
                label="Card Types (separate with commas)"
                name="cardTypes"
                value={Array.isArray(formData.cardTypes) ? formData.cardTypes.join(', ') : formData.cardTypes}
                onChange={handleInputChange}
                error={!!errors.cardTypes}
                helperText={errors.cardTypes || 'e.g., Premium, Standard, Basic'}
                placeholder="Premium, Standard, Basic"
                required
                size={isMobile ? "small" : "medium"}
              />
              {cardTypesArray.length > 0 && (
                <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {cardTypesArray.map((type, index) => (
                    <Chip
                      key={index}
                      label={type}
                      variant="outlined"
                      size="small"
                      color="primary"
                    />
                  ))}
                </Box>
              )}
            </Grid>

            <Grid item xs={12} md={6} size={4}>
              <FormControlLabel
                control={
                  <Switch
                    name="supportDualInsurance"
                    checked={formData.supportDualInsurance}
                    onChange={handleInputChange}
                    size={isMobile ? "small" : "medium"}
                  />
                }
                label="Support Dual Insurance"
              />
            </Grid>

            <Grid item xs={12}>
              <Stack 
                direction={{ xs: "column", sm: "row" }} 
                spacing={2} 
                justifyContent="flex-end" 
                sx={{ mt: 2 }}
              >
                {editingCompany && onCancel && (
                  <Button
                    variant="outlined"
                    startIcon={<Close />}
                    onClick={onCancel}
                    size={isMobile ? "small" : "medium"}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  variant="outlined"
                  startIcon={<Clear />}
                  onClick={handleReset}
                  size={isMobile ? "small" : "medium"}
                >
                  Clear Form
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<Save />}
                  size={isMobile ? "small" : "large"}
                >
                  {editingCompany ? 'Update Company' : 'Register Company'}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

// Company Actions Menu Component
const CompanyActionsMenu = ({ company, onEdit, onDelete, onViewPolicies }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { onEdit(company); handleClose(); }}>
          <Edit sx={{ mr: 1 }} /> Edit Company
        </MenuItem>
        <MenuItem onClick={() => { onViewPolicies(company); handleClose(); }}>
          <ViewList sx={{ mr: 1 }} /> View Policies
        </MenuItem>
        <MenuItem onClick={() => { onDelete(company); handleClose(); }} sx={{ color: 'error.main' }}>
          <Delete sx={{ mr: 1 }} /> Delete Company
        </MenuItem>
      </Menu>
    </>
  );
};

// Responsive Company Card Component
const ResponsiveCompanyCard = ({ company, onEdit, onDelete, onViewPolicies, onCompanySelect }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [expanded, setExpanded] = useState(false);

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={
          <Typography variant={isMobile ? "body1" : "h6"} noWrap>
            {company.name}
          </Typography>
        }
        subheader={
          <Typography variant="caption" color="text.secondary">
            Code: {company.id}
          </Typography>
        }
        action={
          <CompanyActionsMenu
            company={company}
            onEdit={onEdit}
            onDelete={onDelete}
            onViewPolicies={onViewPolicies}
          />
        }
      />
      
      <CardContent sx={{ flexGrow: 1, pt: 0 }}>
        {isMobile ? (
          // Mobile collapsed view
          <>
            <Button
              fullWidth
              variant="text"
              onClick={() => setExpanded(!expanded)}
              endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
              sx={{ mb: 1 }}
            >
              {expanded ? 'Show Less' : 'Show Details'}
            </Button>
            <Collapse in={expanded}>
              <List dense>
                <ListItem sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'secondary.main', width: 32, height: 32 }}>
                      <Code fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Claim Check"
                    secondary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {company.ccc=='Required' || company.ccc==1  ? (
                          <CheckCircle color="success" fontSize="small" />
                        ) : (
                          <Cancel color="error" fontSize="small" />
                        )}
                        <Typography variant="body2">
                          {company.ccc }
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>

                <ListItem sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'accent.main', width: 32, height: 32 }}>
                      <Visibility fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Visits/Month"
                    secondary={`${company.Vsit} visits`}
                  />
                </ListItem>

                <ListItem sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'info.main', width: 32, height: 32 }}>
                      <CreditCard fontSize="small" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Card Types"
                    secondary={
                      <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {company.Seria}
                      </Box>
                    }
                  />
                </ListItem>
              </List>
            </Collapse>
          </>
        ) : (
          // Desktop full view
         <List dense>
            <ListItem>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'secondary.main', width: 32, height: 32 }}>
                  <Code fontSize="small" />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Claim Check"
                secondary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {company.ccc=='Required' || company.ccc==1 ? (
                      <CheckCircle color="success" fontSize="small" />
                    ) : (
                      <Cancel color="error" fontSize="small" />
                    )}
                    <Typography variant="body2">
                      {company.ccc}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'accent.main', width: 32, height: 32 }}>
                  <Visibility fontSize="small" />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Visits/Month"
                secondary={`${company.Vsit} visits`}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'info.main', width: 32, height: 32 }}>
                  <CreditCard fontSize="small" />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Card Types"
                secondary={
                  <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                     {company.Seria}
                  </Box>
                }
              />
            </ListItem>
          </List>
        )}


        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Dual Insurance
            </Typography>
            <Typography variant="body2" fontSize={{ xs: '0.75rem', sm: '0.875rem' }}>
              {company.support ? 'Supported':'Not Supported '}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Show Non-Insurance Medication
            </Typography>
            <Typography variant="body2" fontSize={{ xs: '0.75rem', sm: '0.875rem' }}>
              {company.med=='yes' ? 'Yes' : 'No'}
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Registered: {new Date(company.registeredAt).toLocaleDateString()}
          </Typography>
        </Box>
      </CardContent>

      <Box sx={{ p: 2, pt: 0 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => onEdit(company)}
            startIcon={<Edit />}
            size="small"
          >
            Edit
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={() => onCompanySelect(company)}
            startIcon={<Add />}
            size="small"
          >
            Policy
          </Button>
        </Stack>
      </Box>
    </Card>
  );
};

// Insurance Company List Component with Search
const InsuranceCompanyList = ({ companies, onCompanySelect, onEdit, onDelete, onViewPolicies }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Filter companies based on search term
  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.id.toString().includes(searchTerm) ||
    company.Seria.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (companies.length === 0) {
    return (
      <Alert severity="info">
        No insurance companies registered yet. Use the "Register Company" tab to add your first company.
      </Alert>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
        <Typography variant="h5" sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
          Registered Insurance Companies ({companies.length})
        </Typography>
        
        <TextField
          size={isMobile ? "small" : "medium"}
          placeholder="Search companies..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ minWidth: { xs: '100%', sm: 250 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {filteredCompanies.length === 0 ? (
        <Alert severity="info">
          No companies found matching "{searchTerm}". Try adjusting your search terms.
        </Alert>
      ) : (
        <Grid container spacing={{ xs: 2, sm: 3 }}>
          {filteredCompanies.map((company) => (
            <Grid item xs={12} sm={6} lg={4} key={company.id}>
              <ResponsiveCompanyCard
                company={company}
                onEdit={onEdit}
                onDelete={onDelete}
                onViewPolicies={onViewPolicies}
                onCompanySelect={onCompanySelect}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

// Insurance Policy Form Component - UPDATED VERSION WITH RELOAD
const InsurancePolicyForm = ({ companies, selectedCompany, onSubmit, editingPolicy, onCancel }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Initialize form data properly for both new and editing modes
  const [formData, setFormData] = useState(() => {
    if (editingPolicy) {
      // Find company by name if companyId is not available
      let companyId = editingPolicy.companyId || editingPolicy.company_id || '';
      if (!companyId && editingPolicy.insurance) {
        const foundCompany = companies.find(c => c.name === editingPolicy.insurance);
        companyId = foundCompany ? foundCompany.id : '';
      }
      
      return {
        companyId: companyId,
        policyName: editingPolicy.policy || editingPolicy.policyName || ''
      };
    }
    return {
      companyId: selectedCompany?.id || '',
      policyName: ''
    };
  });

  const [errors, setErrors] = useState({});

  // Update form data when editingPolicy or companies change
  useEffect(() => {
    if (editingPolicy) {
      // Find company by name if companyId is not available
      let companyId = editingPolicy.companyId || editingPolicy.company_id || '';
      if (!companyId && editingPolicy.insurance && companies.length > 0) {
        const foundCompany = companies.find(c => c.name === editingPolicy.insurance);
        companyId = foundCompany ? foundCompany.id : '';
      }
      
      setFormData({
        companyId: companyId,
        policyName: editingPolicy.policy || editingPolicy.policyName || ''
      });
    } else {
      setFormData({
        companyId: selectedCompany?.id || '',
        policyName: ''
      });
    }
  }, [editingPolicy, selectedCompany, companies]);
 
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  
  const validateForm = () => {
    const newErrors = {};

    if (!formData.companyId) {
      newErrors.companyId = 'Please select an insurance company';
    }

    if (!formData.policyName.trim()) {
      newErrors.policyName = 'Policy name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (validateForm()) {
      const selectedCompanyData = companies.find(c => c.id.toString() === formData.companyId.toString());
      
      const processedData = {
        ...formData,
        companyName: selectedCompanyData?.name || '',
        // Include the ID for editing
        ...(editingPolicy && { id: editingPolicy.id })
      };

      const result = await Swal.fire({
        title: 'Confirm / Cancel',
        text: editingPolicy 
          ? "Are You Sure You Want To Update Insurance Policy ?" 
          : "Are You Sure You Want To Save Insurance Policy Information ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes Confirm'
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: 'Processing.......',
          text: 'Please wait',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        }); 

        try {
          if (editingPolicy) {
            const response = await axios.put(updatePolicy(editingPolicy.id), processedData);

            if (response.data.success) {
              successMessage('Update', response.data.message);
              // Call onSubmit with true to trigger refresh
              onSubmit(true);
              handleReset();
            }
            
          } else {
            // Create new policy
            const response = await axios.post(newPolicy, processedData);
                        
            if (response.data.success) {
              successMessage('Save', response.data.message);
              // Call onSubmit with true to trigger refresh
              onSubmit(true);
              handleReset();
            }
          }

        } catch (error) {
          await Swal.fire({
            title: 'Error',
            text: error.response?.data?.message || 'Failed to Save',
            icon: 'error'
          });
        }
      }
    }
  };

  const handleReset = () => {
    setFormData({
      companyId: selectedCompany?.id || '',
      policyName: '',
    });
    setErrors({});
  };

  if (companies.length === 0) {
    return (
      <Alert severity="warning">
        No insurance companies available. Please register at least one insurance company first.
      </Alert>
    );
  }

  // FIX: Get the selected company data based on current form companyId
  const selectedCompanyData = companies.find(c => c.id.toString() === formData.companyId.toString());
  
  // FIX: For editing mode, if we have editingPolicy but no selectedCompanyData, 
  // try to find it using the insurance name from the policy
  let displayCompanyData = selectedCompanyData;
  if (editingPolicy && !selectedCompanyData && editingPolicy.insurance) {
    displayCompanyData = companies.find(c => c.name === editingPolicy.insurance);
    // Update the form data with the found company ID
    if (displayCompanyData && formData.companyId !== displayCompanyData.id.toString()) {
      setFormData(prev => ({...prev, companyId: displayCompanyData.id.toString()}));
    }
  }

  return (
    <Card>
      <CardHeader
        avatar={<Policy color="primary" />}
        title={
          <Typography variant={isMobile ? "h6" : "h5"}>
            {editingPolicy ? "Update Insurance Policy" : "Register Insurance Policy"}
          </Typography>
        }
        subheader={editingPolicy ? "Modify policy information" : "Create a new insurance policy for a registered company"}
        action={
          editingPolicy && onCancel && (
            <IconButton onClick={onCancel}>
              <Close />
            </IconButton>
          )
        }
      />
      <CardContent>

        {/* FIX: Display company info using displayCompanyData */}
        {displayCompanyData && (
          <Box sx={{ mb: 3, p: 2, bgcolor: 'primary.50', borderRadius: 2, border: '1px solid', borderColor: 'primary.200' }}>
            <Typography variant="subtitle1" color="primary">
              {editingPolicy ? 'Current Company: ' : 'Selected Company: '}{displayCompanyData.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Code: {displayCompanyData.id} | Max Visits/Month: {displayCompanyData.Vsit}
            </Typography>
            <Box sx={{ mt: 1 }}>
              {displayCompanyData.Seria}
            </Box>
          </Box>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={{ xs: 2, sm: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
           
            <Grid item xs={12} size={12}>
              <FormControl fullWidth error={!!errors.companyId} size={isMobile ? "small" : "medium"}>
                <InputLabel>Insurance Company</InputLabel>
                <Select
                  name="companyId"
                  value={formData.companyId}
                  onChange={handleInputChange}
                  label="Insurance Company"
                  required
                >
                  {companies.map((company) => (
                    <MenuItem key={company.id} value={company.id}>
                      {company.name} ({company.id})
                    </MenuItem>
                  ))}
                </Select>
                {errors.companyId && (
                  <Typography variant="caption" color="error">
                    {errors.companyId}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} size={12}>
              <TextField
                fullWidth
                label="Policy Name"
                name="policyName"
                value={formData.policyName}
                onChange={handleInputChange}
                error={!!errors.policyName}
                helperText={errors.policyName}
                required
                size={isMobile ? "small" : "medium"}
              />
            </Grid>

            <Grid item xs={12}>
              <Stack 
                direction={{ xs: "column", sm: "row" }} 
                spacing={2} 
                justifyContent="flex-end" 
                sx={{ mt: 2 }}
              >
                {editingPolicy && onCancel && (
                  <Button
                    variant="outlined"
                    startIcon={<Close />}
                    onClick={onCancel}
                    size={isMobile ? "small" : "medium"}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  variant="outlined"
                  startIcon={<Clear />}
                  onClick={handleReset}
                  size={isMobile ? "small" : "medium"}
                >
                  Clear Form
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<Save />}
                  size={isMobile ? "small" : "large"}
                >
                  {editingPolicy ? 'Update Policy' : 'Register Policy'}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

// Policy Actions Menu Component
const PolicyActionsMenu = ({ policy, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { onEdit(policy); handleClose(); }}>
          <Edit sx={{ mr: 1 }} /> Edit Policy
        </MenuItem>
        <MenuItem onClick={() => { onDelete(policy); handleClose(); }} sx={{ color: 'error.main' }}>
          <Delete sx={{ mr: 1 }} /> Delete Policy
        </MenuItem>
      </Menu>
    </>
  );
};

// Responsive Mobile Policy Card
const MobilePolicyCard = ({ policy, onEdit, onDelete }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {policy.insurance}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {policy.policy}
            </Typography>
          </Box>
          <PolicyActionsMenu
            policy={policy}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

// Insurance Policies List Component with Search
const InsurancePoliciesList = ({ policies, companies, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Filter policies based on search term
  const filteredPolicies = policies.filter(policy =>
    policy.insurance.toLowerCase().includes(searchTerm.toLowerCase()) ||
    policy.policy.toLowerCase().includes(searchTerm.toLowerCase()) ||
    policy.id.toString().includes(searchTerm)
  );

  if (policies.length === 0) {
    return (
      <Alert severity="info">
        No insurance policies registered yet. Use the "Register Policy" tab to add your first policy.
      </Alert>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
        <Typography variant="h5" sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
          Insurance Policies ({policies.length})
        </Typography>
        
        <TextField
          size={isMobile ? "small" : "medium"}
          placeholder="Search policies..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ minWidth: { xs: '100%', sm: 250 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      
      {filteredPolicies.length === 0 ? (
        <Alert severity="info">
          No policies found matching "{searchTerm}". Try adjusting your search terms.
        </Alert>
      ) : isMobile ? (
        // Mobile card layout
        <Box sx={{ mt: 2 }}>
          {filteredPolicies.map((policy) => (
            <MobilePolicyCard
              key={policy.id}
              policy={policy}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </Box>
      ) : (
        // Desktop table layout
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.50' }}>
                <TableCell><strong>Insurance Company</strong></TableCell>
                <TableCell><strong>Policy Name</strong></TableCell>
                <TableCell><strong>Actions</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPolicies.map((policy) => (
                <TableRow key={policy.id} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={500}>
                      {policy.insurance}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {policy.policy}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <PolicyActionsMenu
                      policy={policy}
                      onEdit={onEdit}
                      onDelete={onDelete}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

// Company Policies View Component
const CompanyPoliciesView = ({ company, policies, onEdit, onDelete, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const companyPolicies = policies.filter(policy => policy.companyId === company.id);

  return (
    <Card>
      <CardHeader
        avatar={
          company.logo ? (
            <Avatar
              src={company.logo instanceof File ? URL.createObjectURL(company.logo) : company.logo}
              sx={{ width: { xs: 40, sm: 50 }, height: { xs: 40, sm: 50 } }}
              variant="rounded"
            />
          ) : (
            <Avatar sx={{ bgcolor: 'primary.main', width: { xs: 40, sm: 50 }, height: { xs: 40, sm: 50 } }}>
              <Business />
            </Avatar>
          )
        }
        title={
          <Typography variant={isMobile ? "h6" : "h5"}>
            {company.name} Policies
          </Typography>
        }
        subheader={`${companyPolicies.length} policies registered`}
        action={
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        }
      />
      <CardContent>
        {companyPolicies.length === 0 ? (
          <Alert severity="info">
            No policies registered for this company yet.
          </Alert>
        ) : isMobile ? (
          // Mobile card layout
          <Box>
            {companyPolicies.map((policy) => (
              <MobilePolicyCard
                key={policy.id}
                policy={policy}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </Box>
        ) : (
          // Desktop table layout
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.50' }}>
                  <TableCell><strong>Insurance Company</strong></TableCell>
                <TableCell><strong>Policy Name</strong></TableCell>
                <TableCell><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companyPolicies.map((policy) => (
                  <TableRow key={policy.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>
                        {policy.insurance}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {policy.policy}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <PolicyActionsMenu
                        policy={policy}
                        onEdit={onEdit}
                        onDelete={onDelete}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

// Delete Confirmation Dialog
const DeleteConfirmationDialog = ({ open, onClose, onConfirm, title, content }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle sx={{ color: 'error.main' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Delete />
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 1 } }}>
        <Button onClick={onClose} size={isMobile ? "small" : "medium"}>
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          size={isMobile ? "small" : "medium"}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Main Insurance App Component
function Insurance() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [insuranceCompanies, setInsuranceCompanies] = useState([]);
  const [insurancePolicies, setInsurancePolicies] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [editingCompany, setEditingCompany] = useState(null);
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [viewingCompanyPolicies, setViewingCompanyPolicies] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({ open: false, type: null, item: null });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Update the handleCompanyRegistration function
  const handleCompanyRegistration = async (shouldRefresh) => {
    if (shouldRefresh) {
      await loadIns(); // Refresh the companies list
      
      // Reset editing state and switch to companies list tab
      setEditingCompany(null);
     // setTabValue(1); // Switch to Companies List tab
    }
  };

  // Update the handlePolicyRegistration function to reload policies
  const handlePolicyRegistration = async (shouldRefresh) => {
    if (shouldRefresh) {
      await loadpolicyv(); // Refresh the policies list
      
      // Reset editing state and switch to policies list tab
      setEditingPolicy(null);
      //setTabValue(2); // Switch to Policies List tab
    }
  };

  const handleCompanySelect = (company) => {
    setSelectedCompany(company);
    setTabValue(3); // Switch to policy registration tab
  };

  const handleEditCompany = (company) => {
    setEditingCompany(company);
    setTabValue(0); // Switch to company form tab
  };

  const handleEditPolicy = (policy) => {
    setEditingPolicy(policy);
    setTabValue(3); // Switch to policy form tab
  };

  const handleDeleteCompany = (company) => {
    setDeleteDialog({
      open: true,
      type: 'company',
      item: company,
    });
  };

  const handleDeletePolicy = (policy) => {
    setDeleteDialog({
      open: true,
      type: 'policy',
      item: policy,
    });
  };

  
  const handleConfirmDelete = async() => {
   
    const { type, item } = deleteDialog;
    
    if (type === 'company') {
        
        const response = await axios.delete(deleteInsurances(item.name));
        if (response.data.success) {
            successMessage('Delete',response.data.message)
           
             setInsuranceCompanies(prev => prev.filter(company => company.id !== item.id));
             setInsurancePolicies(prev => prev.filter(policy => policy.companyId !== item.id));
             setInsurancePolicies(prev => prev.filter(policy => policy.id !== item.id));
              
        }

     
    
      // Also delete all policies for this company
     
     // setSnackbar({ open: true, message: 'Company and its policies deleted successfully!', severity: 'success' });



    } else if (type === 'policy') {

        const response = await axios.delete(deletePolicy( item.id));
        if (response.data.success) {
            successMessage('Delete',response.data.message)
           
             setInsurancePolicies(prev => prev.filter(policy => policy.id !== item.id));
              
        }

          setInsurancePolicies(prev => prev.filter(policy => policy.id !== item.id));
     // setSnackbar({ open: true, message: 'Policy deleted successfully!', severity: 'success' });
   
    }
    
    setDeleteDialog({ open: false, type: null, item: null });
  };

  const handleViewCompanyPolicies = (company) => {
    setViewingCompanyPolicies(company);
  };

  const handleCancelEdit = () => {
    setEditingCompany(null);
    setEditingPolicy(null);
  };

  useEffect(() => {
    loadIns();
    loadpolicyv();
  }, []); 

  const loadIns = async () => {
    try {
      const response = await axios.get(loadInsurance);
      if (response.data.success) {
        setInsuranceCompanies(response.data.results); 
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Insurance Companies',
        icon: 'error'
      });
    }
  };

  const loadpolicyv = async () => {
    try {
      const response = await axios.get(loadpolicy);
      if (response.data.success) {
        setInsurancePolicies(response.data.results); 
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Policies',
        icon: 'error'
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Business sx={{ mr: 2 }} />
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              fontSize: { xs: '1rem', sm: '1.25rem' }
            }}
          >
            Insurance Management System
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <ResponsiveNavigation
          tabValue={tabValue}
          handleTabChange={handleTabChange}
          editingCompany={editingCompany}
          editingPolicy={editingPolicy}
        />

        <TabPanel value={tabValue} index={0}>
          <InsuranceCompanyForm 
            onSubmit={handleCompanyRegistration} 
            editingCompany={editingCompany}
            onCancel={handleCancelEdit}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          {viewingCompanyPolicies ? (
            <CompanyPoliciesView
              company={viewingCompanyPolicies}
              policies={insurancePolicies}
              onEdit={handleEditPolicy}
              onDelete={handleDeletePolicy}
              onClose={() => setViewingCompanyPolicies(null)}
            />
          ) : (
            <InsuranceCompanyList 
              companies={insuranceCompanies} 
              onCompanySelect={handleCompanySelect}
              onEdit={handleEditCompany}
              onDelete={handleDeleteCompany}
              onViewPolicies={handleViewCompanyPolicies}
            />
          )}
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <InsurancePoliciesList
            policies={insurancePolicies}
            companies={insuranceCompanies}
            onEdit={handleEditPolicy}
            onDelete={handleDeletePolicy}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <InsurancePolicyForm 
            companies={insuranceCompanies}
            selectedCompany={selectedCompany}
            onSubmit={handlePolicyRegistration}
            editingPolicy={editingPolicy}
            onCancel={handleCancelEdit}
          />
        </TabPanel>
      </Container>

      {/* Delete Confirmation Dialog */}
      <DeleteConfirmationDialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, type: null, item: null })}
        onConfirm={handleConfirmDelete}
        title={deleteDialog.type === 'company' ? 'Delete Company' : 'Delete Policy'}
        content={
          deleteDialog.type === 'company'
            ? `Are you sure you want to delete "${deleteDialog.item?.name}"? This will also delete all associated policies.`
            : `Are you sure you want to delete the policy "${deleteDialog.item?.policy}"?`
        }
      />

      {/* Success/Error Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: isMobile ? 'center' : 'left' }}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default Insurance;